module.exports = __webpack_public_path__ + "static/carousel-3829e504dc26e0a02f14c08f1229c97c.jpg";